import { render, staticRenderFns } from "./recruit.vue?vue&type=template&id=bbce289a&"
import script from "./recruit.vue?vue&type=script&lang=js&"
export * from "./recruit.vue?vue&type=script&lang=js&"
import style0 from "./recruit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports